import 'bootstrap/dist/css/bootstrap.min.css';
import './index.css';
import './scss/styles';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './components/Home';
import axios from 'axios';
import React, { useEffect, useState } from 'react';
import NotFound from './components/NotFound';
// import fakeDB from './components/fakeDb.json';
import Container from 'react-bootstrap/Container';

// import ReactTooltip from 'react-tooltip';
import Molecules from './pages/Molecules';
import Pfas from './components/Pfas';
import PfasCycle from './components/PfasCycle';
import PfasDestuction from './components/PfasDestruction';
import PfasImpacts from './components/PfasImpacts';
import PfasIchecProject from './components/PfasIchecProject';
import Map from './pages/Map';
import PfasArchitecture from './components/PfasArchitecture';
import Conclusion from './components/Conclusion';
import PfasCredits from './components/PfasCredits';

function App() {
  // set all molecules with all parameters
  const [moleculeList, setMoleculeList] = useState([]);

  const [error, setError] = useState();

  const getMolecules = async () => {
    await axios
      .get(process.env.REACT_APP_SEARCH_API)
      .then((res) => {
        setMoleculeList(res.data.data);
        // console.log(res.data.data);
      })
      .catch((err) => {
        setError(err.response.data);
        console.log('err', err.response.data);
      });
  };

  useEffect(() => {
    getMolecules();
  }, []);

  // for tooltip const
  // const [content, setContent] = useState('');
  return (
    <Router basename={"/qpfas"}>
      <div className='App'>
        <Container fluid>
          
          <Routes>
            {/* 404 page */}
            <Route path='*' element={<NotFound />} />
            <Route exact path='/' element={<Home />}></Route>
            <Route exact path='/index.html' element={<Home />}></Route>
            <Route exact path='/map' element={<Map />}></Route>
            <Route
              exact
              path='/molecules'
              element={<Molecules molecules={moleculeList} />}
            ></Route>

            <Route exact path='/pfas' element={<Pfas />}></Route>
            <Route exact path='/pfascycle' element={<PfasCycle />}></Route>
            <Route
              exact
              path='/pfasdestruction'
              element={<PfasDestuction />}
            ></Route>
            <Route exact path='/pfasimpacts' element={<PfasImpacts />}></Route>
            <Route
              exact
              path='/pfasproject'
              element={<PfasIchecProject />}
            ></Route>
            <Route
              exact
              path='/pfasarchitecture'
              element={<PfasArchitecture />}
            ></Route>
            <Route exact path='/conclusion' element={<Conclusion />}></Route>
            <Route exact path='/credits' element={<PfasCredits />}></Route>
          </Routes>
        </Container>
      </div>
    </Router>
  );
}

export default App;
